module.exports = new __parcel__URL__("testimonial-gabriel-mobile.45a97971.webp").toString();